import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import moment from "moment";
import {
  apiError,
  getRtoList,
  rtoListSuccessful,
  isModelVisible,
  rtoByIdSuccessful,
  documentChecklistSuccessful,
  uploadDocumentSuccessful,
  verifyDocumentsSuccessful,
  tokenDetailsSuccessful,
  tokenHistorySuccessful,
  pendingReasonSuccessful,
  holdAmountSuccessful,
  holdHistorySuccessful,
  closeRtaSuccessful,
  purchaseHistorySuccessful,
  saleHistorySuccessful,
  rtaHistorySuccessful,
  echallanTransactionsSuccessful,
  createEchallanTransactionSuccessful,
  updateEchallanTransactionSuccessful,
  rtaEmployeesSuccessful,
  approveTokenSuccessful,
  rejectTokenSuccessful,
  // FRC-specific
  frcListSuccessful,
  frcByIdSuccessful,
  uploadFrcDocumentSuccessful,
  verifyFrcDocumentsSuccessful,
  frcDocumentChecklistSuccessful,
  frcTokenDetailsSuccessful,
  frcTokenHistorySuccessful,
  frcEchallanTransactionsSuccessful,
  createFrcEchallanTransactionSuccessful,
  updateFrcEchallanTransactionSuccessful,
  frcOwnershipTransferSuccessful,
  closeFrcSuccessful,
} from "./rtoSlice";
import {
  getList,
  getParamsList,
  postAdd,
  postEdit,
  postFormData,
  postDelete,
  putMultipartFormData,
  patchEdit,
  postMultipartFormData,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

//If user is login then dispatch redux action's are directly from here.
function* RtoListGet({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        // Ordering handled server-side — do not send ordering param
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          if (k == "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k == "end_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/insurancerto/rta/list/",
      params
    );
    yield put(rtoListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* rtoById({ payload }) {
  console.log("payload", payload);
  try {
    const response = yield call(
      getList,
      "/insurancerto/rtaupdate/" + payload,
      {}
    );
    yield put(rtoByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddRto({ payload }) {
  try {
    const response = yield call(
      postEdit,
      "/insurancerto/rtaupdate/" + payload.id,
      payload.rtoObj
    );
    if (response.status === 200) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your RTO Update Successfully.!
            </p>
          </div>
        ),
      });
      yield put(getRtoList({ page: 1, search: "", page_size: 10 }));
      yield put(isModelVisible(false));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Unable to RTO Update. Please try again!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

// Document Checklist
function* getDocumentChecklistSaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/document-checklist/${payload}/`,
      {}
    );
    yield put(documentChecklistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Upload Document - Two-step process:
// 1. Upload file to /system/attachment/ to get attachment ID
// 2. Submit attachment ID to /insurancerto/rta/document-upload/{rta_id}/
function* uploadDocumentSaga({ payload }) {
  try {
    console.log('Upload Document Saga - Payload:', payload);
    
    // Step 1: Upload file to attachment endpoint using standard pattern
    const file = payload.file;
    const fieldName = payload.fieldName;
    
    console.log('Step 1: Uploading file to /system/attachment/');
    const uploadResponse = yield call(postFormData, "/system/attachment/", {
      file: file,
    });
    
    console.log('Step 1: Upload response:', uploadResponse);
    
    // Check for both 200 (OK) and 201 (Created) status codes
    if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
      const attachmentId = uploadResponse.data.id;
      console.log('Step 1: Got attachment ID:', attachmentId);
      
      // Step 2: Submit attachment ID to document-upload endpoint
      const updatePayload = {
        [fieldName + '_id']: attachmentId, // e.g., rcfront_image_id: 123
      };
      
      console.log('Step 2: Submitting to document-upload endpoint');
      console.log('Step 2: RTA ID:', payload.rta_id);
      console.log('Step 2: Update payload:', updatePayload);
      
      const response = yield call(
        postEdit,
        `/insurancerto/rta/document-upload/${payload.rta_id}/`,
        updatePayload
      );
      
      console.log('Step 2: Document upload response:', response);
      
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <div><p className="hp-p1-body hp-text-color-black-80">Document uploaded successfully!</p></div>,
        });
        yield put(uploadDocumentSuccessful(response));
        // Refresh document checklist
        yield put({ type: "rto/getDocumentChecklist", payload: payload.rta_id });
        // Refresh RTO details
        yield put({ type: "rto/getRtoById", payload: payload.rta_id });
      }
    } else {
      console.error('Step 1 failed: Invalid response status or no data', {
        status: uploadResponse.status,
        hasData: !!uploadResponse.data
      });
    }
  } catch (error) {
    console.error('Upload Document Saga Error:', error);
    
    // Check for verification error
    const errorData = error?.response?.data;
    let errorMessage = "Failed to upload document!";
    
    if (errorData) {
      console.log('Error data:', errorData);
      // Check if it's a validation error for already verified document
      const errorKeys = Object.keys(errorData);
      if (errorKeys.length > 0) {
        const firstError = errorData[errorKeys[0]];
        if (Array.isArray(firstError) && firstError[0]?.includes("Already verified")) {
          errorMessage = `Cannot upload: ${firstError[0]}`;
        } else if (typeof firstError === 'string' && firstError.includes("Already verified")) {
          errorMessage = `Cannot upload: ${firstError}`;
        } else if (Array.isArray(firstError)) {
          errorMessage = firstError[0];
        } else if (typeof firstError === 'string') {
          errorMessage = firstError;
        }
      }
    }
    
    // Check for permission error (403)
    if (error?.response?.status === 403) {
      errorMessage = "You don't have permission to upload documents. Please check your permissions (edit_rta or upload_rta_document required).";
    }
    
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// Verify Documents
function* verifyDocumentsSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/verify-documents/${payload.rta_id}`,
      payload.data
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">{payload.data.document_remarks ? "Remarks added successfully!" : "Documents verified successfully!"}</p></div>,
      });
      yield put(verifyDocumentsSuccessful(response));
      // Refresh document checklist
      yield put({ type: "rto/getDocumentChecklist", payload: payload.rta_id });
      // Refresh RTO details
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to verify documents!</p></div>,
    });
    yield put(apiError(error));
  }
}

// Get Token Details
function* getTokenDetailsSaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/token/${payload}/`,
      {}
    );
    yield put(tokenDetailsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Get Token History
function* getTokenHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/token-history/${payload}/`,
      {}
    );
    yield put(tokenHistorySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Update Token Details
function* updateTokenDetailsSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/token/${payload.rta_id}/`,
      payload.data
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Token details updated successfully!</p></div>,
      });
      // Re-fetch token details so the view shows the latest saved values
      yield put({ type: "rto/getTokenDetails", payload: payload.rta_id });
      // Re-fetch token history in case a new entry was archived
      yield put({ type: "rto/getTokenHistory", payload: payload.rta_id });
      // Refresh RTO details
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to update token details!</p></div>,
    });
    yield put(apiError(error));
  }
}

// Approve / Verify Token
function* approveTokenSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/token-approve/${payload}/`,
      {}
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Token verified successfully!</p></div>,
      });
      yield put(approveTokenSuccessful());
      // Refresh RTO details so the UI reflects is_token_verified = true
      yield put({ type: "rto/getRtoById", payload: payload });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to verify token!</p></div>,
    });
    yield put(apiError(error));
  }
}

// Reject / Invalidate Active Token
function* rejectTokenSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/token-reject/${payload.rta_id}/`,
      {
        invalidation_reason: payload.invalidation_reason,
        invalidation_remarks: payload.invalidation_remarks || '',
      }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Token rejected and archived successfully!</p></div>,
      });
      yield put(rejectTokenSuccessful());
      // Refresh token details (now empty), token history, and full RTA record
      yield put({ type: "rto/getTokenDetails", payload: payload.rta_id });
      yield put({ type: "rto/getTokenHistory", payload: payload.rta_id });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.detail || "Failed to reject token!";
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMsg}</p></div>,
    });
    yield put(apiError(error));
  }
}

// Set Pending Reason
function* setPendingReasonSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/pending/${payload.rta_id}/`,
      { pending_reason: payload.reason }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Pending reason set successfully!</p></div>,
      });
      yield put(pendingReasonSuccessful(response));
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Clear Pending Reason
function* clearPendingReasonSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/pending/${payload}/`,
      { clear: true }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Pending reason cleared!</p></div>,
      });
      yield put(pendingReasonSuccessful(response));
      yield put({ type: "rto/getRtoById", payload });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Get Hold Amount
function* getHoldAmountSaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/hold/${payload}/`,
      {}
    );
    
    // Handle response - it might be wrapped in data property or direct
    const holdData = response?.data || response;
    
    console.log('Hold Amount Response:', holdData);
    
    // Transform snake_case to camelCase for the component
    // Check if hold_amount exists and is greater than 0
    const transformedData = holdData && (holdData.hold_amount > 0) ? {
      amount: holdData.hold_amount,
      reason: holdData.hold_reason,
      release_date: holdData.hold_release_date,
      deadline: holdData.hold_deadline,
      forfeited: holdData.hold_forfeited,
      forfeiture_date: holdData.hold_forfeited_on,
      released: holdData.hold_release_date !== null, // Determine if released based on release_date
      release_amount: holdData.release_amount,
      release_type: holdData.release_type,
      release_remarks: holdData.release_remarks,
    } : null;
    
    console.log('Transformed Hold Data:', transformedData);
    
    yield put(holdAmountSuccessful(transformedData));
  } catch (error) {
    console.error('Hold Amount Fetch Error:', error);
    yield put(apiError(error));
  }
}

// Get Hold History
function* getHoldHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/hold-release/${payload}/`,
      {}
    );
    
    // Handle response - the API returns an object with transactions array
    const data = response?.data || response;
    
    // Extract transactions array and transform for display
    const transactions = data?.transactions || [];
    
    // Map API fields to display fields
    const historyList = transactions.map(txn => ({
      id: txn.id,
      release_amount: parseFloat(txn.release_amount),
      payment_destination: txn.payment_destination,
      release_type: txn.payment_destination === 1 ? 'customer' : 'finance',
      release_status: txn.release_status,
      release_status_name: txn.release_status_name,
      customer_name: txn.customer?.fullname || null,
      customer_mobile: txn.customer?.mobile || null,
      customer_code: txn.customer?.code || null,
      finance_type: txn.finance_type,
      finance_name: txn.finance_name,
      release_remarks: txn.remarks || null,
      created_by: txn.createdby,
      created_by_name: txn.createdby_name || null,
      released_at: txn.createdon,
      transfer_proof_attachment: txn.attachment || null, // Transfer proof attachment
      transferred_at: txn.modifiedon || null, // Date when marked as transferred
      transferred_by: txn.modifiedby_name || null, // User who marked as transferred
    }));
    
    // Also store summary data using backend-provided values
    const summaryData = {
      hold_amount: data?.hold_amount,
      total_released: data?.total_released,
      remaining_amount: data?.remaining, // Use backend-provided remaining value
      is_fully_released: data?.is_hold_amount_released,
    };
    
    yield put(holdHistorySuccessful({ transactions: historyList, summary: summaryData }));
  } catch (error) {
    console.error("Hold history fetch error:", error);
    yield put(holdHistorySuccessful({ transactions: [], summary: null })); // Return empty array on error
  }
}

// Set Hold Amount
function* setHoldAmountSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/hold/${payload.rta_id}/`,
      payload.data
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Hold amount set successfully!</p></div>,
      });
      yield put(holdAmountSuccessful(response));
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
      yield put({ type: "rto/getHoldAmount", payload: payload.rta_id });
      yield put({ type: "rto/getHoldHistory", payload: payload.rta_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Release Hold Amount
function* releaseHoldAmountSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/hold-release/${payload.rta_id}/`,
      {
        release_amount: payload.release_amount,
        payment_destination: payload.payment_destination,
        customer_id: payload.customer_id,
        finance_type: payload.finance_type,
        finance_name: payload.finance_name,
        remarks: payload.remarks,
      }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Hold amount released!</p></div>,
      });
      yield put(holdAmountSuccessful(response));
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
      yield put({ type: "rto/getHoldAmount", payload: payload.rta_id });
      yield put({ type: "rto/getHoldHistory", payload: payload.rta_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Mark Hold Release as Transferred
function* markHoldAsTransferredSaga({ payload }) {
  try {
    // Transfer proof document is required when status is 3 (Transferred)
    if (!payload.transfer_proof) {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Transfer proof document is required!</p></div>,
      });
      return;
    }
    
    // First, upload the transfer proof document
    const uploadResponse = yield call(
      postFormData,
      `/system/attachment/`,
      { file: payload.transfer_proof }
    );
    
    if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data?.id) {
      const transferProofId = uploadResponse.data.id;
      
      // Then update the release status with the transfer proof
      const updatePayload = {
        release_status: payload.release_status, // 3 for Transferred
        attachment_id: transferProofId,
      };
      
      if (payload.remarks) {
        updatePayload.remarks = payload.remarks;
      }
      
      const response = yield call(
        postEdit,
        `/insurancerto/rta/hold-release-status/${payload.release_id}/`,
        updatePayload
      );
      
      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <div><p className="hp-p1-body hp-text-color-black-80">Hold amount marked as transferred!</p></div>,
        });
        yield put({ type: "rto/getRtoById", payload: payload.rta_id });
        yield put({ type: "rto/getHoldAmount", payload: payload.rta_id });
        yield put({ type: "rto/getHoldHistory", payload: payload.rta_id });
      }
    } else {
      Modal.error({
        icon: <span className="remix-icon"><RiAlertLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Upload Failed</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to upload transfer proof document. Please try again.</p></div>,
      });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Update RTA Status
function* updateRtaStatusSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/status/${payload.rta_id}/`,
      {
        rtastatus: payload.rtastatus,
        rtastatus_description: payload.rtastatus_description,
        hpt_financier_name: payload.hpt_financier_name,
        hpt_financier_num: payload.hpt_financier_num,
      }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">RTA status updated successfully!</p></div>,
      });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Update RTA Office
function* updateRtaOfficeSaga({ payload }) {
  try {
    const response = yield call(
      patchEdit,
      `/insurancerto/rtaupdate/${payload.rta_id}`,
      {
        rta_office_id: payload.rta_office,
      }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">RTA Office updated successfully!</p></div>,
      });
      yield put({ type: "rto/updateRtaOfficeSuccessful", payload: response });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to update RTA Office!</p></div>,
    });
    yield put(apiError(error));
  }
}

// Update Ownership Status
function* updateOwnershipStatusSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/ownership-status/${payload.rta_id}/`,
      {
        ownership_status: payload.ownership_status,
        ownership_status_description: payload.ownership_status_description,
        ownership_financier_num: payload.ownership_financier_num || '',
      }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Ownership status updated successfully!</p></div>,
      });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Forfeit Hold Amount
function* forfeitHoldAmountSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/hold-forfeit/${payload}/`,
      {}
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Hold amount forfeited!</p></div>,
      });
      yield put(holdAmountSuccessful(response));
      yield put({ type: "rto/getRtoById", payload });
      yield put({ type: "rto/getHoldAmount", payload });
      yield put({ type: "rto/getHoldHistory", payload });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// Close RTA
function* closeRtaSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/rta/close/${payload.rta_id}/`,
      { remarks: payload.remarks }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">RTA closed successfully!</p></div>,
      });
      yield put(closeRtaSuccessful(response));
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
      if (payload.history) {
        payload.history.push("/pages/rto");
      }
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Cannot close RTA. Please check all requirements.";
    const errors = error?.response?.data?.errors || [];
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">{errorMsg}</p>
          {errors.length > 0 && (
            <ul>
              {errors.map((err, idx) => (
                <li key={idx}>{err}</li>
              ))}
            </ul>
          )}
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

// E-Challan Manual Validation - Clear E-Challan
function* validateEChallanSaga({ payload }) {
  try {
    console.log('E-Challan Clear Saga - Payload:', payload);
    
    // Step 1: If payment receipt file exists, upload it first
    let paymentReceiptId = null;
    if (payload.data.payment_receipt_file) {
      console.log('Step 1: Uploading payment receipt to /system/attachment/');
      const uploadResponse = yield call(postFormData, "/system/attachment/", {
        file: payload.data.payment_receipt_file,
      });
      
      if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
        paymentReceiptId = uploadResponse.data.id;
        console.log('Step 1: Got payment receipt attachment ID:', paymentReceiptId);
      }
    }
    
    // Step 2: Submit to E-Challan endpoint to mark as clear
    // API Endpoint: POST /insurancerto/rta/echallan/{rta_id}
    // Expected Payload: {
    //   "is_echallan_clear": true,
    //   "challan_amount": "4000.00",
    //   "paid_amount": "4000.00",
    //   "challan_payment_reference": "5455646464664444",
    //   "challan_payment_receipt_id": 4773092,
    //   "challan_remarks": "string"
    // }
    const echallanPayload = {
      is_echallan_clear: true,
      challan_remarks: payload.data.echallan_remarks || payload.data.remarks || "",
    };
    
    // Add payment fields if provided (when challan was paid)
    if (payload.data.challan_amount) {
      echallanPayload.challan_amount = parseFloat(payload.data.challan_amount).toFixed(2);
    }
    
    // Add paid_amount field (must equal challan_amount for full payment)
    if (payload.data.paid_amount) {
      echallanPayload.paid_amount = parseFloat(payload.data.paid_amount).toFixed(2);
    }
    
    if (payload.data.payment_reference) {
      echallanPayload.challan_payment_reference = payload.data.payment_reference;
    }
    
    if (paymentReceiptId) {
      echallanPayload.challan_payment_receipt_id = paymentReceiptId;
    }
    
    console.log('Step 2: Submitting to E-Challan Clear endpoint');
    console.log('Step 2: E-Challan payload:', echallanPayload);
    
    const response = yield call(
      postEdit,
      `/insurancerto/rta/echallan/${payload.rta_id}/`,
      echallanPayload
    );
    
    console.log('Step 2: E-Challan clear response:', response);
    
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">E-Challan cleared successfully!</p></div>,
      });
      yield put({ type: "rto/validateEChallanSuccessful", payload: response });
      // Refresh RTO details
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    console.error('E-Challan Clear Saga Error:', error);
    
    const errorData = error?.response?.data;
    let errorMessage = "Failed to clear e-challan!";
    
    if (errorData) {
      console.log('Error data:', errorData);
      const errorKeys = Object.keys(errorData);
      if (errorKeys.length > 0) {
        const firstError = errorData[errorKeys[0]];
        if (Array.isArray(firstError)) {
          errorMessage = firstError[0];
        } else if (typeof firstError === 'string') {
          errorMessage = firstError;
        }
      }
    }
    
    // Check for permission error (403)
    if (error?.response?.status === 403) {
      errorMessage = "You don't have permission to clear e-challan. Please check your permissions.";
    }
    
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// ============================================================
// E-CHALLAN TRANSACTION SAGAS (Multi-transaction flow)
// ============================================================

// Get E-Challan Transactions - GET /rta/echallan/<pk>/
function* getEchallanTransactionsSaga({ payload }) {
  try {
    console.log('Get E-Challan Transactions Saga - RTA ID:', payload);
    
    const response = yield call(
      getList,
      `/insurancerto/rta/echallan/${payload}/`,
      {}
    );
    
    console.log('E-Challan Transactions response:', response);
    
    // Response format:
    // {
    //   rta_id, total_challan_amount, total_paid_amount, remaining_amount,
    //   total_transactions, cleared_count, is_all_cleared, transactions: [...]
    // }
    yield put(echallanTransactionsSuccessful(response));
  } catch (error) {
    console.error('Get E-Challan Transactions Error:', error);
    yield put(apiError(error));
  }
}

// Create E-Challan Transaction - POST /rta/echallan/create/<rta_id>/
function* createEchallanTransactionSaga({ payload }) {
  try {
    console.log('Create E-Challan Transaction Saga - Payload:', payload);
    
    // Step 1: If payment receipt file exists, upload it first
    let paymentReceiptId = null;
    if (payload.data.payment_receipt_file) {
      console.log('Uploading payment receipt...');
      const uploadResponse = yield call(postFormData, "/system/attachment/", {
        file: payload.data.payment_receipt_file,
      });
      
      if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
        paymentReceiptId = uploadResponse.data.id;
        console.log('Payment receipt attachment ID:', paymentReceiptId);
      }
    }
    
    // Step 2: Build transaction payload
    const transactionPayload = {
      challan_amount: parseFloat(payload.data.challan_amount || 0).toFixed(2),
    };
    
    // Add paid_amount if provided (partial payment supported)
    if (payload.data.paid_amount !== undefined && payload.data.paid_amount !== null) {
      transactionPayload.paid_amount = parseFloat(payload.data.paid_amount || 0).toFixed(2);
    }
    
    if (payload.data.challan_payment_reference) {
      transactionPayload.challan_payment_reference = payload.data.challan_payment_reference;
    }
    
    if (payload.data.challan_remarks) {
      transactionPayload.challan_remarks = payload.data.challan_remarks;
    }
    
    if (paymentReceiptId) {
      transactionPayload.challan_payment_receipt_id = paymentReceiptId;
    }
    
    console.log('Creating E-Challan transaction with payload:', transactionPayload);
    
    const response = yield call(
      postAdd,
      `/insurancerto/rta/echallan/create/${payload.rta_id}/`,
      transactionPayload
    );
    
    console.log('Create E-Challan Transaction response:', response);
    
    if (response.status === 200 || response.status === 201) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">E-Challan transaction added successfully!</p></div>,
      });
      yield put(createEchallanTransactionSuccessful(response));
      // Refresh transactions and RTO details
      yield put({ type: "rto/getEchallanTransactions", payload: payload.rta_id });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    console.error('Create E-Challan Transaction Error:', error);
    
    const errorData = error?.response?.data;
    let errorMessage = "Failed to add e-challan transaction!";
    
    if (errorData) {
      const errorKeys = Object.keys(errorData);
      if (errorKeys.length > 0) {
        const firstError = errorData[errorKeys[0]];
        if (Array.isArray(firstError)) {
          errorMessage = firstError[0];
        } else if (typeof firstError === 'string') {
          errorMessage = firstError;
        }
      }
    }
    
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// Update E-Challan Transaction - PUT /rta/echallan/create/<rta_id>/
function* updateEchallanTransactionSaga({ payload }) {
  try {
    console.log('Update E-Challan Transaction Saga - Payload:', payload);
    
    // Step 1: If payment receipt file exists, upload it first
    let paymentReceiptId = payload.data.challan_payment_receipt_id || null;
    if (payload.data.payment_receipt_file) {
      console.log('Uploading payment receipt...');
      const uploadResponse = yield call(postFormData, "/system/attachment/", {
        file: payload.data.payment_receipt_file,
      });
      
      if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
        paymentReceiptId = uploadResponse.data.id;
        console.log('Payment receipt attachment ID:', paymentReceiptId);
      }
    }
    
    // Step 2: Build update payload (must include transaction id)
    const updatePayload = {
      id: payload.data.id, // Transaction ID is required for update
    };
    
    if (payload.data.paid_amount !== undefined) {
      updatePayload.paid_amount = parseFloat(payload.data.paid_amount || 0).toFixed(2);
    }
    
    if (payload.data.challan_amount !== undefined) {
      updatePayload.challan_amount = parseFloat(payload.data.challan_amount).toFixed(2);
    }
    
    if (payload.data.challan_payment_reference) {
      updatePayload.challan_payment_reference = payload.data.challan_payment_reference;
    }
    
    if (payload.data.challan_remarks !== undefined) {
      updatePayload.challan_remarks = payload.data.challan_remarks;
    }
    
    if (paymentReceiptId) {
      updatePayload.challan_payment_receipt_id = paymentReceiptId;
    }
    
    console.log('Updating E-Challan transaction with payload:', updatePayload);
    
    const response = yield call(
      postEdit,
      `/insurancerto/rta/echallan/create/${payload.rta_id}/`,
      updatePayload
    );
    
    console.log('Update E-Challan Transaction response:', response);
    
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">E-Challan payment updated successfully!</p></div>,
      });
      yield put(updateEchallanTransactionSuccessful(response));
      // Refresh transactions and RTO details
      yield put({ type: "rto/getEchallanTransactions", payload: payload.rta_id });
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    console.error('Update E-Challan Transaction Error:', error);
    
    const errorData = error?.response?.data;
    let errorMessage = "Failed to update e-challan payment!";
    
    if (errorData) {
      const errorKeys = Object.keys(errorData);
      if (errorKeys.length > 0) {
        const firstError = errorData[errorKeys[0]];
        if (Array.isArray(firstError)) {
          errorMessage = firstError[0];
        } else if (typeof firstError === 'string') {
          errorMessage = firstError;
        }
      }
    }
    
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// Mark Ownership as Transferred
function* markOwnershipTransferredSaga({ payload }) {
  try {
    console.log('Mark Ownership Transferred Saga - Payload:', payload);
    
    const updatePayload = {
      transfer_type: payload.transfer_type,
      transferred_to_firm_name: payload.transferred_to_firm_name || null,
      representative_id: payload.representative_id || null,
      transferred_to_staff_id: payload.transferred_to_staff_id || null,
      transferred_to_customer_id: payload.transferred_to_customer_id || null,
      is_ownership_transferred: true,
    };
    
    console.log('Submitting ownership transfer to API endpoint');
    console.log('Update payload:', updatePayload);
    
    const response = yield call(
      postEdit,
      `/insurancerto/rta/ownership-transfer/${payload.rta_id}/`,
      updatePayload
    );
    
    console.log('Ownership transfer response:', response);
    
    if (response.status === 200) {
      // Determine transfer target for success message
      let transferTarget = "the specified party";
      if (payload.transfer_type === 1) {
        transferTarget = payload.transferred_to_firm_name || "Firm";
      } else if (payload.transfer_type === 2) {
        transferTarget = "Staff Member";
      } else if (payload.transfer_type === 3) {
        transferTarget = "Customer";
      }
      
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Ownership has been successfully transferred to {transferTarget}!</p></div>,
      });
      yield put({ type: "rto/ownershipTransferSuccessful", payload: response });
      // Refresh RTO details
      yield put({ type: "rto/getRtoById", payload: payload.rta_id });
    }
  } catch (error) {
    console.error('Mark Ownership Transferred Saga Error:', error);
    
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to mark ownership as transferred!</p></div>,
    });
    yield put(apiError(error));
  }
}

// Get Purchase History for Vehicle
function* getPurchaseHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/purchasevehiclehistory/${payload.id}`,
      {}
    );
    yield put(purchaseHistorySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Get Sale History for Vehicle
function* getSaleHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/salevehiclehistory/${payload.id}`,
      {}
    );
    yield put(saleHistorySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Get RTA History
function* getRtaHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/rta/history/${payload}/`,
      {}
    );
    // Extract history array from response
    yield put(rtaHistorySuccessful(response.history || response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// Get RTA Employees (staff for ownership transfer)
function* getRtaEmployeesSaga({ payload }) {
  try {
    const params = payload || { page: 1, page_size: 100 };
    const response = yield call(
      getParamsList,
      `/masters/rta/mini/employees/`,
      params
    );
    yield put({ type: "rto/rtaEmployeesSuccessful", payload: response });
  } catch (error) {
    yield put(apiError(error));
  }
}

export function* watchGetDocumentChecklist() {
  yield takeEvery("rto/getDocumentChecklist", getDocumentChecklistSaga);
}
export function* watchUploadDocument() {
  yield takeEvery("rto/uploadDocument", uploadDocumentSaga);
}
export function* watchVerifyDocuments() {
  yield takeEvery("rto/verifyDocuments", verifyDocumentsSaga);
}
export function* watchGetTokenDetails() {
  yield takeEvery("rto/getTokenDetails", getTokenDetailsSaga);
}
export function* watchGetTokenHistory() {
  yield takeEvery("rto/getTokenHistory", getTokenHistorySaga);
}
export function* watchUpdateTokenDetails() {
  yield takeEvery("rto/updateTokenDetails", updateTokenDetailsSaga);
}
export function* watchApproveToken() {
  yield takeEvery("rto/approveToken", approveTokenSaga);
}
export function* watchRejectToken() {
  yield takeEvery("rto/rejectToken", rejectTokenSaga);
}
export function* watchSetPendingReason() {
  yield takeEvery("rto/setPendingReason", setPendingReasonSaga);
}
export function* watchClearPendingReason() {
  yield takeEvery("rto/clearPendingReason", clearPendingReasonSaga);
}
export function* watchGetHoldAmount() {
  yield takeEvery("rto/getHoldAmount", getHoldAmountSaga);
}
export function* watchGetHoldHistory() {
  yield takeEvery("rto/getHoldHistory", getHoldHistorySaga);
}
export function* watchSetHoldAmount() {
  yield takeEvery("rto/setHoldAmount", setHoldAmountSaga);
}
export function* watchReleaseHoldAmount() {
  yield takeEvery("rto/releaseHoldAmount", releaseHoldAmountSaga);
}
export function* watchMarkHoldAsTransferred() {
  yield takeEvery("rto/markHoldAsTransferred", markHoldAsTransferredSaga);
}
export function* watchUpdateRtaStatus() {
  yield takeEvery("rto/updateRtaStatus", updateRtaStatusSaga);
}
export function* watchUpdateRtaOffice() {
  yield takeEvery("rto/updateRtaOffice", updateRtaOfficeSaga);
}
export function* watchUpdateOwnershipStatus() {
  yield takeEvery("rto/updateOwnershipStatus", updateOwnershipStatusSaga);
}
export function* watchForfeitHoldAmount() {
  yield takeEvery("rto/forfeitHoldAmount", forfeitHoldAmountSaga);
}
export function* watchCloseRta() {
  yield takeEvery("rto/closeRta", closeRtaSaga);
}
export function* watchValidateEChallan() {
  yield takeEvery("rto/validateEChallan", validateEChallanSaga);
}
export function* watchGetEchallanTransactions() {
  yield takeEvery("rto/getEchallanTransactions", getEchallanTransactionsSaga);
}
export function* watchCreateEchallanTransaction() {
  yield takeEvery("rto/createEchallanTransaction", createEchallanTransactionSaga);
}
export function* watchUpdateEchallanTransaction() {
  yield takeEvery("rto/updateEchallanTransaction", updateEchallanTransactionSaga);
}
export function* watchMarkOwnershipTransferred() {
  yield takeEvery("rto/markOwnershipTransferred", markOwnershipTransferredSaga);
}
export function* watchGetPurchaseHistory() {
  yield takeEvery("rto/getPurchaseHistory", getPurchaseHistorySaga);
}
export function* watchGetSaleHistory() {
  yield takeEvery("rto/getSaleHistory", getSaleHistorySaga);
}
export function* watchGetRtaHistory() {
  yield takeEvery("rto/getRtaHistory", getRtaHistorySaga);
}
export function* watchGetRtaEmployees() {
  yield takeEvery("rto/getRtaEmployees", getRtaEmployeesSaga);
}

// ============================================================
// FRC CREATE SAGA
// ============================================================
function* createFrcRtaSaga({ payload }) {
  try {
    const response = yield call(
      postAdd,
      "/insurancerto/rta/create/frc/",
      payload.data
    );
    if (response.status === 200 || response.status === 201) {
      const newRtaId = response.data.id;
      const newRtaCode = response.data.code;

      // Close modal & stop loading first
      yield put({ type: "rto/createFrcRtaSuccessful" });
      yield put({ type: "rto/isFrcModalVisible", payload: false });

      // Show success — redirect happens when user clicks "View FRC"
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">FRC Created Successfully</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              FRC record <strong>{newRtaCode}</strong> has been created.
            </p>
            <p className="hp-p1-body hp-text-color-black-60" style={{ marginTop: 4 }}>
              Click <strong>View FRC</strong> to open the FRC detail screen and complete
              the registration process.
            </p>
          </div>
        ),
        okText: "View FRC",
        onOk: () => {
          if (payload.history) {
            payload.history.push(`/pages/frc-view/${newRtaId}`);
          }
        },
        cancelText: "Stay Here",
        okCancel: true,
      });
    }
  } catch (error) {
    const errorData = error?.response?.data;
    let errorMessage = "Failed to create FRC record!";
    if (errorData) {
      const keys = Object.keys(errorData);
      if (keys.length > 0) {
        const first = errorData[keys[0]];
        if (Array.isArray(first)) errorMessage = first[0];
        else if (typeof first === "string") errorMessage = first;
      }
    }
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

export function* watchCreateFrcRta() {
  yield takeEvery("rto/createFrcRta", createFrcRtaSaga);
}

// ============================================================
// FRC MANAGEMENT SAGAS  (dedicated /insurancerto/frc/ endpoints)
// ============================================================

// ── 1. FRC List  GET /insurancerto/frc/list/ ──────────────────────────────────
function* getFrcListSaga({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] !== "" && k != null && k !== "no_of_pages") {
          if (k === "start_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else if (k === "end_date") {
            params[k] = moment(data[k]).format("YYYY-MM-DD");
          } else {
            params[k] = data[k];
          }
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/insurancerto/frc/list/", params);
    yield put(frcListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 2. FRC Detail  GET /insurancerto/frc/<id>/ ────────────────────────────────
function* getFrcByIdSaga({ payload }) {
  try {
    const response = yield call(getList, `/insurancerto/frc/${payload}/`, {});
    yield put(frcByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 3. FRC Status Update  PUT /insurancerto/frc/status/<id>/ ─────────────────
function* updateFrcStatusSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/frc/status/${payload.frc_id}/`,
      { rtastatus: payload.rtastatus, rtastatus_description: payload.rtastatus_description || "" }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">FRC status updated successfully!</p></div>,
      });
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 4. FRC Document Upload  PUT /insurancerto/frc/document-upload/<id>/ ───────
// Two-step: POST file → /system/attachment/ → get ID → PUT to frc/document-upload/
function* uploadFrcDocumentSaga({ payload }) {
  try {
    const uploadResponse = yield call(postFormData, "/system/attachment/", {
      file: payload.file,
    });

    if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
      const attachmentId = uploadResponse.data.id;
      const updatePayload = { [payload.fieldName + "_id"]: attachmentId };

      const response = yield call(
        postEdit,
        `/insurancerto/frc/document-upload/${payload.frc_id}/`,
        updatePayload
      );

      if (response.status === 200) {
        Modal.success({
          icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: <div><p className="hp-p1-body hp-text-color-black-80">Document uploaded successfully!</p></div>,
        });
        yield put(uploadFrcDocumentSuccessful());
        yield put({ type: "rto/getFrcDocumentChecklist", payload: payload.frc_id });
        yield put({ type: "rto/getFrcById", payload: payload.frc_id });
      }
    }
  } catch (error) {
    const errorData = error?.response?.data;
    let errorMessage = "Failed to upload document!";
    if (errorData) {
      const keys = Object.keys(errorData);
      if (keys.length > 0) {
        const first = errorData[keys[0]];
        if (Array.isArray(first) && first[0]?.includes("Already verified")) {
          errorMessage = `Cannot upload: ${first[0]}`;
        } else if (Array.isArray(first)) {
          errorMessage = first[0];
        } else if (typeof first === "string") {
          errorMessage = first;
        }
      }
    }
    if (error?.response?.status === 403) {
      errorMessage = "You don't have permission to upload FRC documents (upload_frc_document or edit_frc required).";
    }
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 5. FRC Document Verify  PUT /insurancerto/frc/document-verify/<id>/ ───────
function* verifyFrcDocumentsSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/frc/document-verify/${payload.frc_id}/`,
      payload.data
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">{payload.data.document_remarks ? "Remarks added!" : "Documents verified successfully!"}</p></div>,
      });
      yield put(verifyFrcDocumentsSuccessful());
      yield put({ type: "rto/getFrcDocumentChecklist", payload: payload.frc_id });
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to verify FRC documents!</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 6. FRC Document Checklist  GET /insurancerto/frc/document-checklist/<id>/ ─
function* getFrcDocumentChecklistSaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/frc/document-checklist/${payload}/`,
      {}
    );
    yield put(frcDocumentChecklistSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 7. FRC Token Details  GET /insurancerto/frc/token/<id>/ ──────────────────
function* getFrcTokenDetailsSaga({ payload }) {
  try {
    const response = yield call(getList, `/insurancerto/frc/token/${payload}/`, {});
    yield put(frcTokenDetailsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 8. FRC Token History  GET /insurancerto/frc/token-history/<id>/ ──────────
function* getFrcTokenHistorySaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/frc/token-history/${payload}/`,
      {}
    );
    yield put(frcTokenHistorySuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 9. FRC Token Update  PUT /insurancerto/frc/token/<id>/ ───────────────────
function* updateFrcTokenDetailsSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/frc/token/${payload.frc_id}/`,
      payload.data
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">FRC token updated successfully!</p></div>,
      });
      yield put({ type: "rto/getFrcTokenDetails", payload: payload.frc_id });
      yield put({ type: "rto/getFrcTokenHistory", payload: payload.frc_id });
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to update FRC token!</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 10. FRC E-Challan Transactions  GET /insurancerto/frc/echallan/<id>/ ──────
function* getFrcEchallanTransactionsSaga({ payload }) {
  try {
    const response = yield call(
      getList,
      `/insurancerto/frc/echallan/${payload}/`,
      {}
    );
    yield put(frcEchallanTransactionsSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

// ── 11. FRC Create E-Challan  POST /insurancerto/frc/echallan/create/<id>/ ────
function* createFrcEchallanTransactionSaga({ payload }) {
  try {
    let paymentReceiptId = null;
    if (payload.data.payment_receipt_file) {
      const uploadResponse = yield call(postFormData, "/system/attachment/", {
        file: payload.data.payment_receipt_file,
      });
      if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
        paymentReceiptId = uploadResponse.data.id;
      }
    }

    const transactionPayload = {
      challan_amount: parseFloat(payload.data.challan_amount || 0).toFixed(2),
    };
    if (payload.data.paid_amount != null) {
      transactionPayload.paid_amount = parseFloat(payload.data.paid_amount || 0).toFixed(2);
    }
    if (payload.data.challan_payment_reference) {
      transactionPayload.challan_payment_reference = payload.data.challan_payment_reference;
    }
    if (payload.data.challan_remarks) {
      transactionPayload.challan_remarks = payload.data.challan_remarks;
    }
    if (paymentReceiptId) {
      transactionPayload.challan_payment_receipt_id = paymentReceiptId;
    }

    const response = yield call(
      postAdd,
      `/insurancerto/frc/echallan/create/${payload.frc_id}/`,
      transactionPayload
    );

    if (response.status === 200 || response.status === 201) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">E-Challan added successfully!</p></div>,
      });
      yield put(createFrcEchallanTransactionSuccessful());
      yield put({ type: "rto/getFrcEchallanTransactions", payload: payload.frc_id });
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    const errorData = error?.response?.data;
    let errorMessage = "Failed to add e-challan!";
    if (errorData) {
      const keys = Object.keys(errorData);
      if (keys.length > 0) {
        const first = errorData[keys[0]];
        errorMessage = Array.isArray(first) ? first[0] : (typeof first === "string" ? first : errorMessage);
      }
    }
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 12. FRC Update E-Challan  PUT /insurancerto/frc/echallan/create/<id>/ ─────
function* updateFrcEchallanTransactionSaga({ payload }) {
  try {
    let paymentReceiptId = payload.data.challan_payment_receipt_id || null;
    if (payload.data.payment_receipt_file) {
      const uploadResponse = yield call(postFormData, "/system/attachment/", {
        file: payload.data.payment_receipt_file,
      });
      if ((uploadResponse.status === 200 || uploadResponse.status === 201) && uploadResponse.data) {
        paymentReceiptId = uploadResponse.data.id;
      }
    }

    const updatePayload = { id: payload.data.id };
    if (payload.data.paid_amount !== undefined) {
      updatePayload.paid_amount = parseFloat(payload.data.paid_amount || 0).toFixed(2);
    }
    if (payload.data.challan_amount !== undefined) {
      updatePayload.challan_amount = parseFloat(payload.data.challan_amount).toFixed(2);
    }
    if (payload.data.challan_payment_reference) {
      updatePayload.challan_payment_reference = payload.data.challan_payment_reference;
    }
    if (payload.data.challan_remarks !== undefined) {
      updatePayload.challan_remarks = payload.data.challan_remarks;
    }
    if (paymentReceiptId) {
      updatePayload.challan_payment_receipt_id = paymentReceiptId;
    }

    const response = yield call(
      postEdit,
      `/insurancerto/frc/echallan/create/${payload.frc_id}/`,
      updatePayload
    );

    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">E-Challan payment updated!</p></div>,
      });
      yield put(updateFrcEchallanTransactionSuccessful());
      yield put({ type: "rto/getFrcEchallanTransactions", payload: payload.frc_id });
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    const errorData = error?.response?.data;
    let errorMessage = "Failed to update e-challan payment!";
    if (errorData) {
      const keys = Object.keys(errorData);
      if (keys.length > 0) {
        const first = errorData[keys[0]];
        errorMessage = Array.isArray(first) ? first[0] : (typeof first === "string" ? first : errorMessage);
      }
    }
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">{errorMessage}</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 13. FRC Ownership Transfer  PUT /insurancerto/frc/ownership-transfer/<id>/ 
function* markFrcOwnershipTransferredSaga({ payload }) {
  try {
    const updatePayload = {
      transfer_type: payload.transfer_type,
      transferred_to_firm_name:    payload.transferred_to_firm_name    || null,
      transferred_to_staff_id:     payload.transferred_to_staff_id     || null,
      transferred_to_customer_id:  payload.transferred_to_customer_id  || null,
      is_ownership_transferred:    true,
    };

    const response = yield call(
      postEdit,
      `/insurancerto/frc/ownership-transfer/${payload.frc_id}/`,
      updatePayload
    );

    if (response.status === 200) {
      let target = "the specified party";
      if (payload.transfer_type === 1) target = payload.transferred_to_firm_name || "Firm";
      else if (payload.transfer_type === 2) target = "Staff Member";
      else if (payload.transfer_type === 3) target = "Customer";

      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">Ownership transferred to {target}!</p></div>,
      });
      yield put(frcOwnershipTransferSuccessful());
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
    }
  } catch (error) {
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: <div><p className="hp-p1-body hp-text-color-black-80">Failed to transfer FRC ownership!</p></div>,
    });
    yield put(apiError(error));
  }
}

// ── 14. Close FRC  PUT /insurancerto/frc/close/<id>/ ─────────────────────────
function* closeFrcSaga({ payload }) {
  try {
    const response = yield call(
      postEdit,
      `/insurancerto/frc/close/${payload.frc_id}/`,
      { remarks: payload.remarks || "" }
    );
    if (response.status === 200) {
      Modal.success({
        icon: <span className="remix-icon"><RiCheckboxCircleLine /></span>,
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: <div><p className="hp-p1-body hp-text-color-black-80">FRC closed successfully!</p></div>,
      });
      yield put(closeFrcSuccessful());
      yield put({ type: "rto/getFrcById", payload: payload.frc_id });
      if (payload.history) {
        payload.history.push("/pages/frc");
      }
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || "Cannot close FRC. Please check all requirements.";
    const errors = error?.response?.data?.errors || [];
    Modal.error({
      icon: <span className="remix-icon"><RiAlertLine /></span>,
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">{errorMsg}</p>
          {errors.length > 0 && (
            <ul>{errors.map((err, idx) => <li key={idx}>{err}</li>)}</ul>
          )}
        </div>
      ),
    });
    yield put(apiError(error));
  }
}

// ── FRC Watchers ──────────────────────────────────────────────────────────────
export function* watchGetFrcList() {
  yield takeEvery("rto/getFrcList", getFrcListSaga);
}
export function* watchGetFrcById() {
  yield takeEvery("rto/getFrcById", getFrcByIdSaga);
}
export function* watchUpdateFrcStatus() {
  yield takeEvery("rto/updateFrcStatus", updateFrcStatusSaga);
}
export function* watchUploadFrcDocument() {
  yield takeEvery("rto/uploadFrcDocument", uploadFrcDocumentSaga);
}
export function* watchVerifyFrcDocuments() {
  yield takeEvery("rto/verifyFrcDocuments", verifyFrcDocumentsSaga);
}
export function* watchGetFrcDocumentChecklist() {
  yield takeEvery("rto/getFrcDocumentChecklist", getFrcDocumentChecklistSaga);
}
export function* watchGetFrcTokenDetails() {
  yield takeEvery("rto/getFrcTokenDetails", getFrcTokenDetailsSaga);
}
export function* watchGetFrcTokenHistory() {
  yield takeEvery("rto/getFrcTokenHistory", getFrcTokenHistorySaga);
}
export function* watchUpdateFrcTokenDetails() {
  yield takeEvery("rto/updateFrcTokenDetails", updateFrcTokenDetailsSaga);
}
export function* watchGetFrcEchallanTransactions() {
  yield takeEvery("rto/getFrcEchallanTransactions", getFrcEchallanTransactionsSaga);
}
export function* watchCreateFrcEchallanTransaction() {
  yield takeEvery("rto/createFrcEchallanTransaction", createFrcEchallanTransactionSaga);
}
export function* watchUpdateFrcEchallanTransaction() {
  yield takeEvery("rto/updateFrcEchallanTransaction", updateFrcEchallanTransactionSaga);
}
export function* watchMarkFrcOwnershipTransferred() {
  yield takeEvery("rto/markFrcOwnershipTransferred", markFrcOwnershipTransferredSaga);
}
export function* watchCloseFrc() {
  yield takeEvery("rto/closeFrc", closeFrcSaga);
}

export function* watchGetRtoList() {
  yield takeEvery("rto/getRtoList", RtoListGet);
}
export function* watchRtoAdd() {
  yield takeEvery("rto/rtoAdd", AddRto);
}

export function* watchGetRtoById() {
  yield takeEvery("rto/getRtoById", rtoById);
}

function* rtoSaga() {
  yield all([
    // ── RTA ──────────────────────────────────────────────────────────────
    fork(watchGetRtoList),
    fork(watchRtoAdd),
    fork(watchGetRtoById),
    fork(watchGetDocumentChecklist),
    fork(watchUploadDocument),
    fork(watchVerifyDocuments),
    fork(watchGetTokenDetails),
    fork(watchGetTokenHistory),
    fork(watchUpdateTokenDetails),
    fork(watchApproveToken),
    fork(watchRejectToken),
    fork(watchSetPendingReason),
    fork(watchClearPendingReason),
    fork(watchGetHoldAmount),
    fork(watchGetHoldHistory),
    fork(watchSetHoldAmount),
    fork(watchReleaseHoldAmount),
    fork(watchMarkHoldAsTransferred),
    fork(watchUpdateRtaStatus),
    fork(watchUpdateRtaOffice),
    fork(watchUpdateOwnershipStatus),
    fork(watchForfeitHoldAmount),
    fork(watchValidateEChallan),
    fork(watchGetEchallanTransactions),
    fork(watchCreateEchallanTransaction),
    fork(watchUpdateEchallanTransaction),
    fork(watchMarkOwnershipTransferred),
    fork(watchCloseRta),
    fork(watchGetPurchaseHistory),
    fork(watchGetSaleHistory),
    fork(watchGetRtaHistory),
    fork(watchGetRtaEmployees),
    fork(watchCreateFrcRta),
    // ── FRC ──────────────────────────────────────────────────────────────
    fork(watchGetFrcList),
    fork(watchGetFrcById),
    fork(watchUpdateFrcStatus),
    fork(watchUploadFrcDocument),
    fork(watchVerifyFrcDocuments),
    fork(watchGetFrcDocumentChecklist),
    fork(watchGetFrcTokenDetails),
    fork(watchGetFrcTokenHistory),
    fork(watchUpdateFrcTokenDetails),
    fork(watchGetFrcEchallanTransactions),
    fork(watchCreateFrcEchallanTransaction),
    fork(watchUpdateFrcEchallanTransaction),
    fork(watchMarkFrcOwnershipTransferred),
    fork(watchCloseFrc),
  ]);
}

export default rtoSaga;
